import React, { useEffect, useState } from "react";
import Ratings from "../Ratings";
import { AiFillHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_wishlist_products,
  remove_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import toast from "react-hot-toast";
import { Heart } from "lucide-react";
import axios from "../../api/api"
import { formatCurrency, fetchExchangeRates } from "../../utils/currencyUtils";

const Wishlist = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);
  const { wishlist, successMessage } = useSelector((state) => state.card);
  useEffect(() => {
    fetchExchangeRates().then(() => setExchangeLoaded(true));
  }, []);
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data } = await axios.get("/account/get-details", {
          withCredentials: true,
        });
        if (data.currency) {
          setCurrencyCode(data.currency);
        }
      } catch (error) {
        // Handle error silently
      }
    };

    if (userInfo && userInfo.id) {
      fetchUserDetails();
    }
  }, []);
  useEffect(() => {
    dispatch(get_wishlist_products(userInfo.id));
  }, []);

  useEffect(() => {
    if (successMessage) {
      // toast.success(successMessage);
      dispatch(messageClear());
    }
  }, [successMessage]);

  if (wishlist.length === 0) {
    return (
      <div className="w-full h-[400px] flex items-center justify-center">
        <div className="text-center text-gray-400">
          <p>No items in your wishlist</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full grid grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-6">
      {wishlist.map((p, i) => (
        <div
          key={i}
          className="bg-[#070707] group transition-all duration-500 hover:shadow-md cursor-pointer"
        >
          <div className="relative overflow-hidden">
            {p.discount !== 0 && (
              <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                {p.discount}%
              </div>
            )}
            <Link to={p.shopName ? `/${p.shopName}/product/details/${p.productId}` : `/product/details/${p.productId}`} state={{ fromStore: location.state?.fromStore }} className="">
              <img
                className="sm:w-full w-full h-[240px] nex_img_cover"
                src={p.image}
                alt="product"
              />
            </Link>
            <ul className="flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
            </ul>
          </div>
          <div className="py-3 text-white px-2">

            <div className="flex justify-between items-center gap-3 p-2">
              <h2>{p.name}</h2>
              <span className="text-lg font-bold"> {formatCurrency(p.price, currencyCode, p.currency)}</span>
            </div>
            <div className="gap-3 p-2">
              <div className="flex items-center justify-between mb-4">
                <div className="flex">
                  <Ratings ratings={p.rating} />
                </div>
                <div onClick={() => dispatch(remove_wishlist({ wishlistId: p._id, storeName: location.state?.fromStore }))} className="w-[38px] h-[38px] cursor-pointer rounded-full flex justify-center items-center bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all">
                  <Heart size={20} className="fill-red-500 text-red-500" />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Wishlist;